import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableReCaptchaForMemberTopUp',
  initialState: false,
  reducers: {
    setEnableReCaptchaForMemberTopUp(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableReCaptchaForMemberTopUp } = slice.actions;

export default slice.reducer;
